import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ReactNode } from 'react';

export default function AdminRoute({ children }: { children: ReactNode }) {
  const { authUser, currentUser, loading } = useAuth();

  if (loading) return null;

  if (!authUser) return <Navigate to="/SignIn" replace />;

  if (currentUser?.role !== 'admin') return <Navigate to="/" replace />;

  return <>{children}</>;
}
